<h2 mat-dialog-title>{{ isEditMode ? 'Edit Announcement' : 'Create Announcement' }}</h2>
<mat-dialog-content>
  <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">

    <!-- New Type Dropdown -->
    <div class="form-field">
      <label for="type">Type</label>
      <mat-select formControlName="type" id="type">
        <mat-option value="kampanje">Kampanje</mat-option>
        <mat-option value="announcement">Announcement</mat-option>
      </mat-select>
    </div>


    <!-- Announcement Field -->
    <div class="form-field">
      <label for="announcement">Announcement</label>
      <input type="text" id="announcement" formControlName="announcement">
    </div>



    <!-- Conditionally show fields based on the type -->
    <!-- If type is "kampanje", show only one droplist -->
    <div *ngIf="subscriptionForm.get('type').value === 'kampanje'">
      <div class="form-field">
        <label for="kampanje">Kampanje Options</label>
        <mat-select id="kampanje" formControlName="kampanje" multiple>
          <mat-option *ngFor="let option of kampanjeArr" [value]="option.id" [disabled]="option.disable">
            {{ option.name }} - {{ option.selectedDays }}
          </mat-option>
        </mat-select>
        
      </div>
    </div>

    <!-- If type is "announcement", show all other fields -->
    <div *ngIf="subscriptionForm.get('type').value === 'announcement'">
      <!-- System Dropdown -->
      <div class="form-field">
        <label for="systems">System:</label>
        <input matInput type="text" placeholder="Search system" (keyup)="filterSystems($event.target.value)" />
        <mat-select #mySelect id="systems" formControlName="systems" multiple>
          <mat-option *ngFor="let system of filteredSystems" [value]="system.systemId">
            {{ system.systemName }}
          </mat-option>
        </mat-select>
      </div>

      <!-- Start Time -->
      <div class="form-field">
        <label for="startTime">Start Time:</label>
        <input matInput type="time" id="startTime" formControlName="startTime">
      </div>

      <!-- End Time -->
      <div class="form-field">
        <label for="endTime">End Time:</label>
        <input matInput type="time" id="endTime" formControlName="endTime">
      </div>

      <div class="form-field">
        <label for="windowColor">Announcement Color:</label>
        <input matInput type="color" id="windowColor" formControlName="windowColor">
      </div>

      <div class="form-field">
        <label for="textColor">Text Color:</label>
        <input matInput type="color" id="textColor" formControlName="textColor">
      </div>

      <!-- Priority Dropdown -->
      <div class="form-field">
        <label>Priority</label>
        <mat-select id="priority" formControlName="priority">
          <mat-option value="0">High</mat-option>
          <mat-option value="1">Low</mat-option>
        </mat-select>
      </div>

      <!-- Week Days Checkboxes -->
      <div class="form-field">
        <label>Select Week Days:</label>
        <mat-select id="selectedDays" formControlName="selectedDays" multiple>
          <mat-option *ngFor="let day of daysOfWeek" [value]="day.index">
            {{ day.name }}
          </mat-option>
        </mat-select>
      </div>

      <!-- Active Dropdown -->
      <div class="form-field">
        <label>Active</label>
        <mat-select id="active" formControlName="active">
          <mat-option value="true">Yes</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
      </div>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!subscriptionForm.valid" (click)="onSubmit()">
    {{ isEditMode ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>